import { render, staticRenderFns } from "./CreateEducationLevel.vue?vue&type=template&id=349dd30e&"
import script from "./CreateEducationLevel.vue?vue&type=script&lang=js&"
export * from "./CreateEducationLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports